/*******************************************************************************
 * Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : DeleteDLMUWProduct.tsx
 *
 * Project Title : Checkout
 *
 * Description   : Initial version
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : Jaladi Suresh
 *
 * @Date         : May 27, 2030
 *
 * @Version      : Version 1.0
 *  
 ******************************************************************************/
import * as React from "react";
import { Modal, Button } from "@scuf/common";
import "@scuf/common/honeywell/theme.css";
import "./../ReviewOrder/reviewOrder.css";

interface DeleteDLMUWProductProps {    
    open: boolean;
    onClose?: Function;
    onContinue?: Function;       
}

class DeleteDLMUWProduct extends React.PureComponent<DeleteDLMUWProductProps> {
  render() {
    return (
      <React.Fragment>
        <Modal
          size="small"
          //closeIcon={true}
          //onClose={() => { this.props.onClose && this.props.onClose() }} 
          open={this.props.open}
          closeOnDimmerClick={false}
          closeOnDocumentClick={false}
        >
          <Modal.Content>
            <p>
              If you change your Billing Address, All DLMU-W product(s) added to the cart will be deleted.
            </p>
          </Modal.Content>
          <Modal.Footer>
            <div className="display-flex">
              <Button
                type="secondary"
                className="co-secondary-button"
                content="CANCEL"
                data-testid="cancel"
                onClick = {() => { this.props.onClose && this.props.onClose() }}
              />
              <Button
                type="primary"
                className="co-primary-button"
                content="OK"
                data-testid="ok"
                onClick = {() => { this.props.onContinue && this.props.onContinue() }}
              />
            </div>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    );
  }
}

export default DeleteDLMUWProduct;
